import globals from '../globals';

const agilOneMixin = {
  mounted() {
    if (typeof window.$A1Config !== 'undefined') {
      return;
    }
    if (!globals.siteConfig.agilOneIsEnabled) {
      return;
    }
    this.A1Config = {
      key: globals.thirdPartyApps.agilOne.agilOneDailyAuthenticationKey,
      tenantId: globals.thirdPartyApps.agilOne.tenantId,
      domain: globals.siteId,
      host: globals.thirdPartyApps.agilOne.agilOneHostUrl,
      // host: 'cs-gcp-api6.agilone.com',
    };
    // loading AgilOne Library
    const agilOneConfig = document.createElement('script');
    agilOneConfig.textContent = `var $A1Config = ${JSON.stringify(
      this.A1Config,
    )}`;
    window.A1Helper = {
      processTargets: (targets) => {
        const newTargets = [];
        if (Array.isArray(targets)) {
          // Convert the targets array to $A1 targets
          targets.forEach((target) => {
            target.brandId = globals.siteId;
            newTargets.push($A1.Target(target));
          });
        } else {
          const target = targets;
          target.brandId = globals.siteId;
          newTargets.push($A1.Target(target));
        }
        return newTargets;
      },
      processCustomer: () => {
        const newCustomer = {};
        if (this.globals.getIsLoggedIn()) {
          newCustomer.c_brandId = this.globals.siteId;
          newCustomer.SourceCustomerNumber = `BID=${globals.siteId}&SCN=${this.globals.userInfo.customerId}` ;
          newCustomer.Email = this.globals.userInfo.email;
        } else {
          newCustomer.Cookie = window.A1Helper.processCookie();
        }
        // Get the anonymous cookie
        return $A1.Customer(newCustomer);
      },
      processCookie: () => {
        const value = document.cookie;
        const parts = value.split('; ');
        let v2 = [];
        parts.forEach((c) => {
          if (c.indexOf('_pk_id.') > -1) {
            const v = c.toString().split('=');
            v2 = v[1].toString().split('.');
          }
        });
        return v2[0];
      },
      waitingEvents: [],
      send: (eventData) => {
        const event = {
          Cookie: window.A1Helper.processCookie(),
          type: eventData.event,
          customer: window.A1Helper.processCustomer(),
          targets: window.A1Helper.processTargets(eventData.targets),
        };
        window.$A1
          .Event(event)
          .send()
          .then(
            (d) => {
              if (eventData.callback) {
                eventData.callback.call();
              }
            },
            (e) => {
              if (eventData.callback) {
                eventData.callback.call();
              }
            },
          );
      },
    };
    window.handleScriptLoaded = function() {
      if (window.A1Helper.waitingEvents.length > 0) {
        // loop through the events.
        window.A1Helper.waitingEvents.forEach((eventData) => {
          window.A1Helper.send(eventData);
        });
      }
    };
    document.head.appendChild(agilOneConfig);
    const agilOneJS = document.createElement('script');
    agilOneJS.setAttribute('src', globals.agilOneScriptURL);
    agilOneJS.setAttribute('onload', 'handleScriptLoaded()');
    document.head.appendChild(agilOneJS);
  },
  data() {
    return {
      A1Config: {},
      hybrisResponseData: {},
    };
  },

  methods: {
    send(eventData) {
      if (typeof $A1 === 'undefined') {
        // Script has not loaded yet.
        // Store the eventData on aa queue and wait $A1 to load.

        window.A1Helper.waitingEvents.push(eventData);
      } else {
        window.A1Helper.send(eventData);
      }
    },

    /**
     * trackSearchResults function
     * @param  {object}   dataObj contains search term and total result
     * @param  {object}   searchTerm contains search term and total result
     * @return {object}        null
     */

    trackSearchResults(dataObj, callback) {
      if (!globals.siteConfig.agilOneIsEnabled) {
        if (callback) callback.call();
        return;
      }

      const ecommerceObject = {
        event: 'onsiteSearch',
        targets: {
          SearchTerm: dataObj.freeTextSearch,
        },
      };
      if (callback) {
        ecommerceObject.callback = callback;
      }
      this.send(ecommerceObject);
    },
    /**
     * trackCategoryBrowsed function
     * @param  {object}   dataObj contains details of the category browsed
     * @return {object}          null
     */
    trackCategoryBrowsed(dataObj, callback) {
      if (!globals.siteConfig.agilOneIsEnabled) {
        if (callback) callback.call();
        return;
      }
      const ecommerceObject = {
        event: 'categoryBrowsed',
        targets: {
          SourceProductCategoryNumber: dataObj,
        },
      };
      if (callback) {
        ecommerceObject.callback = callback;
      }
      this.send(ecommerceObject);
    },
    /**
     * trackProductBrowsed function
     * @param  {object}   dataObj contains details of product productBrowsed
     * @return {object}          null
     */
    trackProductBrowsed(dataObj, callback) {
      if (!globals.siteConfig.agilOneIsEnabled) {
        if (callback) callback.call();
        return;
      }
      const ecommerceObject = {
        event: 'productBrowsed',
        targets: {
          SourceProductNumber: `BID=${globals.siteId}&SPN=${dataObj.code}`,  // code stands for productId
        },
      };
      if (callback) {
        ecommerceObject.callback = callback;
      }
      this.send(ecommerceObject);
    },

    /**
     * trackAddToCart function
     * @param  {object}   dataObj contains details of product added to cart
     * @return {object}          null
     */
    trackAddToCart(dataObj, callback) {
      if (!globals.siteConfig.agilOneIsEnabled) {
        if (callback) callback.call();
        return;
      }
      const ecommerceObject = {
        event: 'cartUpdated',
        targets: dataObj,
      };
      if (callback) {
        ecommerceObject.callback = callback;
      }
      this.send(ecommerceObject);
    },

    /**
     * trackRemoveFromCart function
     * @param  {object}   dataObj contains details of product removed from cart
     * @return {object}          null
     */
    trackRemoveFromCart(dataObj, callback) {
      if (!globals.siteConfig.agilOneIsEnabled) {
        if (callback) callback.call();
        return;
      }
      const ecommerceObject = {
        event: 'cartUpdated',
        targets: dataObj,
      };
      if (callback) {
        ecommerceObject.callback = callback;
      }
      this.send(ecommerceObject);
    },

    /**
     * trackCheckout function
     * @param  {object}   dataObj contains details of product during checkout
     * @return {object}          null
     */

    trackCheckout(dataObj, callback) {
      if (!globals.siteConfig.agilOneIsEnabled) {
        if (callback) callback.call();
        return;
      }
      if (dataObj) {
        const ecommerceObject = {
          event: 'checkout',
          targets: {
            SourceTransactionNumber: `BID=${globals.siteId}&STN=${dataObj}`,
          },
        };
        if (callback) {
          ecommerceObject.callback = callback;
        }
        this.send(ecommerceObject);
      }
    },
    /**
     * trackLogin function
     * @param  {object}   dataObj contains details of logged in user
     * @return {object}          null
     */
    trackLogin(dataObj, callback) {
      if (!globals.siteConfig.agilOneIsEnabled) {
        if (callback) callback.call();
        return;
      }
      const ecommerceObject = {
        event: 'login',
        targets: {
          Email: dataObj,
        },
      };
      if (callback) {
        ecommerceObject.callback = callback;
      }
      this.send(ecommerceObject);
    },
    /**
     * trackLogout function
     * @param  {object}   dataObj contains details of the user who logged out
     * @return {object}          null
     */
    trackLogout(dataObj, callback) {
      if (!globals.siteConfig.agilOneIsEnabled) {
        if (callback) callback.call();
        return;
      }
      const ecommerceObject = {
        event: 'Logout',
        targets: {
          Email: dataObj,
        },
      };
      if (callback) {
        ecommerceObject.callback = callback;
      }
      this.send(ecommerceObject);
    },
    /**
     * trackNewsLetterSignup function
     * @param  {object}   dataObj contains details of the user who signed up for newsletter
     * @return {object}          null
     */
    trackNewsLetterSignup(dataObj, callback) {
      if (!globals.siteConfig.agilOneIsEnabled) {
        if (callback) callback.call();
        return;
      }
      const ecommerceObject = {
        event: 'login',
        targets: {
          Email: dataObj,
        },
      };
      if (callback) {
        ecommerceObject.callback = callback;
      }
      this.send(ecommerceObject);
    },
  },
};

export default agilOneMixin;



// WEBPACK FOOTER //
// ./src/components/common/mixins/agilone-mixin.js